import React from 'react';
import { Platform, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../store/reducers';
import { reportActions } from '../../store/reducers/report';

interface QuestionnaireHeaderLeftProps {
  onPressBack: () => void;
}

const QuestionnaireHeaderLeft: React.FC<QuestionnaireHeaderLeftProps> = ({ onPressBack }) => {
  const dispatch = useDispatch();
  const drawerVisible = useSelector((state: RootState) => state.report.drawerVisible);

  const handlePress = () => {
    if (drawerVisible) {
      dispatch(reportActions.toggleDrawerVisibility());
    } else {
      onPressBack();
    }
  };

  return (
    <TouchableOpacity style={styles.backButton} onPress={handlePress}>
      <Icon
        name={Platform.OS === 'ios' ? 'chevron-left' : 'arrow-left'}
        size={Platform.OS === 'ios' ? 32 : 24}
        color="white"
      />
    </TouchableOpacity>
  );
};

export default QuestionnaireHeaderLeft;

const styles = StyleSheet.create({
  backButton: {
    paddingLeft: 16
  }
});
